/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Walkthrough_P1_Trial_FeeInputs */

const en_subscription_walkthrough_p1_trial_fee = /** @type {(inputs: Subscription_Walkthrough_P1_Trial_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel anytime, no penalties or fees`)
};

const ar_subscription_walkthrough_p1_trial_fee = /** @type {(inputs: Subscription_Walkthrough_P1_Trial_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إلغاء في أي وقت، لا توجد عقوبات أو رسوم`)
};

const de_subscription_walkthrough_p1_trial_fee = /** @type {(inputs: Subscription_Walkthrough_P1_Trial_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jederzeit stornieren, keine Strafen oder Gebühren`)
};

const es_subscription_walkthrough_p1_trial_fee = /** @type {(inputs: Subscription_Walkthrough_P1_Trial_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelación en cualquier momento, sin penalizaciones ni gastos`)
};

const fr_subscription_walkthrough_p1_trial_fee = /** @type {(inputs: Subscription_Walkthrough_P1_Trial_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulez à tout moment, sans pénalités ni frais`)
};

const it_subscription_walkthrough_p1_trial_fee = /** @type {(inputs: Subscription_Walkthrough_P1_Trial_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla in qualsiasi momento, senza penali o commissioni`)
};

const ja_subscription_walkthrough_p1_trial_fee = /** @type {(inputs: Subscription_Walkthrough_P1_Trial_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いつでもキャンセル可能、違約金や手数料はかかりません`)
};

const ko_subscription_walkthrough_p1_trial_fee = /** @type {(inputs: Subscription_Walkthrough_P1_Trial_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`패널티나 수수료 없이 언제든 취소할 수 있어요`)
};

const pt_br_subscription_walkthrough_p1_trial_fee = /** @type {(inputs: Subscription_Walkthrough_P1_Trial_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancele quando quiser, sem taxas nem penalidades`)
};

const ru_subscription_walkthrough_p1_trial_fee = /** @type {(inputs: Subscription_Walkthrough_P1_Trial_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отписывайтесь в любое время без штрафов и комиссии`)
};

const th_subscription_walkthrough_p1_trial_fee = /** @type {(inputs: Subscription_Walkthrough_P1_Trial_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยกเลิกได้ตลอดเวลา ไม่มีค่าปรับหรือค่าธรรมเนียม`)
};

const tr_subscription_walkthrough_p1_trial_fee = /** @type {(inputs: Subscription_Walkthrough_P1_Trial_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İstediğin zaman iptal et, ceza veya ücret yok`)
};

const zh_cn_subscription_walkthrough_p1_trial_fee = /** @type {(inputs: Subscription_Walkthrough_P1_Trial_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试用期间可以随时取消，无额外费用`)
};

const zh_tw_subscription_walkthrough_p1_trial_fee = /** @type {(inputs: Subscription_Walkthrough_P1_Trial_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`試用期間可以隨時取消，無額外費用`)
};

/**
* | output |
* | --- |
* | "Cancel anytime, no penalties or fees" |
*
* @param {Subscription_Walkthrough_P1_Trial_FeeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_walkthrough_p1_trial_fee = /** @type {((inputs?: Subscription_Walkthrough_P1_Trial_FeeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Walkthrough_P1_Trial_FeeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_walkthrough_p1_trial_fee(inputs)
	if (locale === "ar") return ar_subscription_walkthrough_p1_trial_fee(inputs)
	if (locale === "de") return de_subscription_walkthrough_p1_trial_fee(inputs)
	if (locale === "es") return es_subscription_walkthrough_p1_trial_fee(inputs)
	if (locale === "fr") return fr_subscription_walkthrough_p1_trial_fee(inputs)
	if (locale === "it") return it_subscription_walkthrough_p1_trial_fee(inputs)
	if (locale === "ja") return ja_subscription_walkthrough_p1_trial_fee(inputs)
	if (locale === "ko") return ko_subscription_walkthrough_p1_trial_fee(inputs)
	if (locale === "pt_br") return pt_br_subscription_walkthrough_p1_trial_fee(inputs)
	if (locale === "ru") return ru_subscription_walkthrough_p1_trial_fee(inputs)
	if (locale === "th") return th_subscription_walkthrough_p1_trial_fee(inputs)
	if (locale === "tr") return tr_subscription_walkthrough_p1_trial_fee(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_walkthrough_p1_trial_fee(inputs)
	return zh_tw_subscription_walkthrough_p1_trial_fee(inputs)
});